import { OrderedMap } from 'immutable';
import ObjectType from 'automation-ui-references/object-types/ObjectType';
import { getObjectTypeId } from 'automation-ui-references/object-types/objectTypeUtils';
const formatObjectTypesResponse = response => {
  if (!Array.isArray(response)) {
    throw new Error('Unexpected response');
  }
  return response.reduce((entityMap, currentEntity) => {
    const objectType = new ObjectType(currentEntity);
    return entityMap.set(getObjectTypeId(objectType), objectType);
  }, OrderedMap());
};
export default formatObjectTypesResponse;